(function () {

  'use strict';

  angular.module('eclipseApp.login')
    .controller('signinController',
      ['$state',
        '$location',
        'janrainService',
        'commonService',
        'downgradedUserService',
        '$scope',
        'signinService',
        '$timeout',
        'timerService',
        function ($state,
                  $location,
                  janrainService,
                  commonService,
                  downgradedUserService,
                  $scope,
                  signinService,
                  $timeout,
                  timerService) {
          var init = function () {
            signinService.setLoadingIndicator(false);
            timerService.stopTimer();
            commonService.loginProcessed = false;
            var signinInterceptor = $('.signin-interceptor');
            downgradedUserService.resetLoginState(true);
            $timeout(function () {
              if (signinInterceptor.length > 0) {
                signinInterceptor.click();
              } else {
                $('body').append('<a class="signin-interceptor" style="display:none;"></a>');
                $('.signin-interceptor').click();
                // janrainService.easyLoginRedirect('RIVERPAGE', _.get($state, 'params.sessionExpired', false));
              }
            }, 10);
          };

          init();

          $scope.showLoadingIndicator = function () {
            return signinService.getLoadingIndicator();
          };
        }]);

})();
